import React from 'react';

function loadScriptOnce({ id, src, attrs = {} }) {
  if (document.getElementById(id)) return;
  const s = document.createElement('script');
  s.id = id;
  s.src = src;
  for (const [k, v] of Object.entries(attrs)) {
    if (v == null) continue;
    s.setAttribute(k, String(v));
  }
  document.head.appendChild(s);
}

export default function AnalyticsProviders() {
  React.useEffect(() => {
    const gaId = import.meta.env.VITE_GA_MEASUREMENT_ID;
    if (gaId) {
      loadScriptOnce({
        id: 'ga-gtag',
        src: `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(gaId)}`,
        attrs: { async: 'true' },
      });
      window.dataLayer = window.dataLayer || [];
      window.gtag =
        window.gtag ||
        function gtag() {
          window.dataLayer.push(arguments);
        };
      window.gtag('js', new Date());
      window.gtag('config', gaId, { send_page_view: false });
    }

    const plausibleDomain = import.meta.env.VITE_PLAUSIBLE_DOMAIN;
    if (plausibleDomain) {
      loadScriptOnce({
        id: 'plausible',
        src: 'https://plausible.io/js/script.js',
        attrs: { defer: 'true', 'data-domain': plausibleDomain },
      });
    }

    const posthogKey = import.meta.env.VITE_POSTHOG_KEY;
    const posthogHost = import.meta.env.VITE_POSTHOG_HOST || 'https://app.posthog.com';
    if (posthogKey) {
      if (!window.posthog) {
        const posthog = (window.posthog = window.posthog || []);
        posthog._i = [];
        posthog.init = function init(key, config = {}) {
          const instance = { _i: [], config };
          posthog._i.push([key, config, instance]);
          return instance;
        };
        window.posthog.init(posthogKey, { api_host: posthogHost });
      }

      loadScriptOnce({
        id: 'posthog',
        src: `${String(posthogHost).replace(/\/+$/, '')}/static/array.js`,
        attrs: { async: 'true' },
      });
    }
  }, []);

  return null;
}
